import React, { useEffect, useState } from "react";
import Layout from "../components/Layout";
import PageTitle from "../components/PageTitle";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import { addEvent, updateEvent } from "../redux/actions/eventsAction";
import { EVENT_UPDATE_RESET } from "../redux/constants/eventsConstant";

const EditEventsScreen = () => {
  const { uuid } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const listEventState = useSelector((state) => state.listEvent);
  const { event } = listEventState;
  const eventEditState = useSelector((state) => state.eventEdit);
  const { success } = eventEditState;
  const [name, setName] = useState("");
  const [date, setDate] = useState("");
  const [venue, setVenue] = useState("");
  const [description, setDescription] = useState("");
  const handleEditForm = (e) => {
    e.preventDefault();
    dispatch(updateEvent(name, date, venue, description, uuid));
  };

  useEffect(() => {
    if (success) {
      dispatch({ type: EVENT_UPDATE_RESET });
      navigate("/events");
    }
  }, [success]);
  return (
    <Layout>
      <PageTitle title="Edit Event" />
      <div className="card">
        <div className="card-body">
          <form onSubmit={handleEditForm}>
            <div className="row mb-3">
              <label htmlFor="name" className="col-sm-2 col-form-label">
                Event Name
              </label>
              <div className="col-sm-10">
                <input
                  className="form-control"
                  type="text"
                  placeholder="Enter Name Of Event"
                  onChange={(e) => setName(e.target.value)}
                  defaultValue={event && event.title}
                />
              </div>
            </div>
            <div className="row mb-3">
              <label
                htmlFor="example-week-input"
                className="col-sm-2 col-form-label"
              >
                Event Date
              </label>
              <div className="col-sm-10">
                <input
                  className="form-control"
                  type="date"
                  id="example-week-input"
                  onChange={(e) => setDate(e.target.value)}
                  value={moment(event && event.date).format("YYYY-MM-DD")}
                />
              </div>
            </div>
            <div className="row mb-3">
              <label htmlFor="name" className="col-sm-2 col-form-label">
                Event Venue
              </label>
              <div className="col-sm-10">
                <input
                  className="form-control"
                  type="text"
                  placeholder="Enter Venue"
                  onChange={(e) => setVenue(e.target.value)}
                  defaultValue={event && event.venue}
                />
              </div>
            </div>
            <div className="row mb-3">
              <label htmlFor="name" className="col-sm-2 col-form-label">
                Event Description
              </label>
              <div className="col-sm-10">
                <textarea
                  className="form-control"
                  type="text"
                  rows={9}
                  placeholder="Enter Small Description For Event"
                  onChange={(e) => setDescription(e.target.value)}
                  defaultValue={event && event.description}
                ></textarea>
              </div>
            </div>

            <button type="submit" className="btn btn-primary">
              Edit
            </button>
          </form>
        </div>
      </div>
    </Layout>
  );
};

export default EditEventsScreen;
